"use client";

/**
 * @deprecated Use `PageShell` from `components/ui/v2/layout/page-shell`.
 */
export type { PageShellProps as MaintainerGridPageV2Props } from "components/ui/v2/layout/page-shell";
export { PageShell as MaintainerGridPageV2 } from "components/ui/v2/layout/page-shell";
